<ht-modal [options]="modalOptions" #modal>
  {{ bodyText }}
</ht-modal>
